"use client";

import dynamic from "next/dynamic";
import { useRef } from "react";

import { useProfilePreviewStore } from "../model/profile-preview-store";

// KAN-298: модал 300+ строк не должен сидеть в бандле/DOM всего приложения —
// чанк подгружается при первом открытии превью и остаётся смонтированным дальше.
const ProfilePreviewModalLazy = dynamic(
  () =>
    import("./profile-preview-modal").then((m) => ({
      default: m.ProfilePreviewModal,
    })),
  { ssr: false },
);

export function ProfilePreviewModalHost() {
  const state = useProfilePreviewStore((s) => s.state);
  const mountedOnceRef = useRef(false);
  if (state !== "hidden") mountedOnceRef.current = true;
  if (!mountedOnceRef.current) return null;
  return <ProfilePreviewModalLazy />;
}
